import React from "react";
import AnimationRevealPage from "../helpers/AnimationRevealPage";
import TwoColumnWithAnImage from "../components/hero/TwoColumnWithAnImage";
import TwoColWithButton from "../components/features/TwoColWithButton";
import Footer from "../components/footers/MiniCenteredFooter";
import SectionHeader from "../components/dividers/SectionHeader";
import AboutMe from "../components/features/AboutMe";

// Stuff
import projectINC from "../images/Project-Inc-Mockup2.png";
import daybreakMockup from "../images/daybreak-mockup.png";
import authorPicture from "../images/author-picture-2.png";
import eHawker from "../images/E-Hawker.png";

const Home = () => {
  return (
    <AnimationRevealPage>
      <TwoColumnWithAnImage />
      <TwoColWithButton
        subheading="Built with MySQL, Express, React, and NodeJS"
        heading={
          <>
            <span style={{ color: "#ffffff" }}>About me</span>
          </>
        }
        description={
          <>
            <span style={{ color: "#ffffff" }}>
              Hi! I am a Fullstack web developer based in Singapore. I have a
              passion for creating user experiences that are seamless,
              meaningful, and impactful. Understanding he human experience is
              essential for creating useful and effective products. I enjoy
              using my skill set to empower people to accomplish their goals. I
              create digitial experience that make life easier.
            </span>
          </>
        }
        textOnLeft={false}
        imageSrc={authorPicture}
        backgroundColor="#6415ff"
        backgroundImage={{}}
        enableButton={false}
        additionals={{ marginBottom: "3rem" }}
      />
      <SectionHeader title="Projects" />
      <TwoColWithButton
        subheading="Built with MySQL, Express, React, and NodeJS"
        heading={
          <>
            Document Tracker -{" "}
            <span style={{ color: "#6415ff" }}>Project eISO.</span>
          </>
        }
        description="A web application created for users to track their documents and keep track of their progress to help follow the requirements outlined in the ISO 9001 Standard. The standard is used by organizations to demonstrate their ability to consistently provide products and services that meet customer and regulatory requirements and to demonstrate continuous improvement."
        textOnLeft={true}
        imageSrc={projectINC}
        primaryButtonText="Work in progress..."
        primaryButtonUrl="/"
      />
      <TwoColWithButton
        subheading="Built with Java"
        heading={
          <>
            Meditation App - <span style={{ color: "#6415ff" }}>Daybreak</span>
          </>
        }
        description="This app is a meditation app that helps you stay focused and maintain high efficiency when doing our work. It is a great way to stay mindful of your day-to-day activities and to stay on top of your mental health."
        textOnLeft={false}
        imageSrc={daybreakMockup}
        primaryButtonUrl="/Daybreak"
      />
      <TwoColWithButton
        subheading="Built with MySQL and Java Servlets"
        description="This is a web application created for hawkers during the pandemic. It is a platform where hawkers can post their products and services for sale and view other hawker's products and services."
        heading={
          <>
            Food Delivery Platform -{" "}
            <span style={{ color: "#6415ff" }}>E Hawker</span>
          </>
        }
        imageSrc={eHawker}
        textOnLeft={true}
      />
      <Footer />
    </AnimationRevealPage>
  );
};

export default Home;
